import {
  post, postJson, get, putJson, delect,
} from '@/utils/request';

export function openLockApi(data) {
  return post(
    '/cargoWay/ajax-machine/Unlocking',
    data,
  );
}
export function batchSettingStatusApi(data) {
  return postJson(
    '/machine/shelf/batch_setting/status',
    data,
  );
}
export function batchSettingStockApi(data) {
  return postJson(
    '/machine/shelf/batch_setting/stock',
    data,
  );
}
export function batchShelfSettingApi(data) {
  return postJson(
    '/machine/shelf/setting',
    data,
  );
}
export function batchShelfSettingTestApi(data) {
  return postJson(
    '/machine/shelf/batch_test',
    data,
  );
}
export function shelfSettingTestApi(data) {
  return postJson(
    '/machine/shelf/test',
    data,
  );
}
export function postCloseCouponApi(data) {
  return postJson(
    '/machine/shelf/coupon/close',
    data,
  );
}
export function getReplenishmentListApi(data) {
  return get(
    '/machine/replenishment/list',
    data,
  );
}
export function getReplenishmentQueryListApi(data) {
  return get(
    '/machine/replenishment/queryList',
    data,
  );
}
export function getReplenishmentDetailApi(data) {
  return get(
    '/machine/replenishment/detail',
    data,
  );
}

export function getSalesInventoryListApi(data) {
  return get(
    '/machine/ajax-machineStock',
    data,
  );
}

export function getMachineTypeListApi(data) {
  return get(
    '/vending/machine/type',
    data,
  );
}

export function getMachineRunStatusApi(data) {
  return get(
    '/machine/getMachineRunStatus',
    data,
  );
}

export function exhibitionMachineRunStatusApi(data) {
  return get(
    '/machine/exhibitionMachineRunStatus',
    data,
  );
}

export function updateMachineNameApi(data) {
  return postJson(
    '/cargoWay/updateMachineName',
    data,
  );
}

export function getMachineReplenishmentListApi(data) {
  return get(
    '/machine/replenishment',
    data,
  );
}

export function getMachineReplenishmentShelfListApi(data) {
  return get(
    `/machine/replenishment/shelfList/${data.machineId}`,
    data,
  );
}

export function settingMachineStockApi(data) {
  return postJson(
    '/machine/replenishment/settingMachineStock',
    data,
  );
}

export function settingFullInventoryApi(data) {
  return postJson(
    `/machine/replenishment/settingFullInventory/${data.machineId}`,
    data,
  );
}

export function setMachineLocationApi(data) {
  return putJson(
    '/machines/detail/location',
    data,
  );
}

export function replenishmentOrderCreateApi(data) {
  return postJson(
    'machine/replenishment/order/create',
    data,
  );
}

export function getReplenishmentOrderApi(data) {
  return get(
    `/machine/replenishment/order/${data.replenishNo}`,
  );
}

export function getReplenishmentOrderListApi(data) {
  return get(
    '/machine/replenishment/order',
    data,
  );
}

export function completeReplenishmentOrderApi(data) {
  return putJson(
    `/machine/replenishment/order/${data.id}`,
  );
}

export function deleteReplenishmentOrderApi(data) {
  return delect(
    `/machine/replenishment/order/${data.id}`,
  );
}

export function getReplenishmentOrderItemApi(data) {
  return get(
    '/machine/replenishment/order/item',
    data,
  );
}

export function getMachineLightControlApi(data) {
  return get(
    '/machines/detail/machineLightControl',
    data,
  );
}

export function setMachineLightControlApi(data) {
  return postJson(
    '/machines/detail/machineLightControl',
    data,
  );
}

export function getMachineOnlineRecordApi(data) {
  return get(
    '/machines/online/offline/record',
    data,
  );
}

// 获取设备温度，用于设置时反显
export function getMachineTemperatureApi(data) {
  return get(
    `/machines/detail/getMachineTemperature`,
    data
  )
}

// 设置温度
export function setMachineTemperatureApi(data) {
  return putJson(
    `/machines/detail/setMachineTemperature`,
    data
  )
}

// 获取设备控制设置
export function getMachineControlSettingApi(data) {
  return get(
    `/machines/detail/machineControlSetting`,
    data
  )
}

// 设备控制设置
export function setMachineControlSettingApi(data) {
  return postJson(
    `/machines/detail/machineControlSetting`,
    data
  )
}

// 获取定时营业配置
export function getMachineBusinessHoursApi(data) {
  return get(
    `/machines/detail/machineBusinessHours`,
    data
  )
}

// 设置定时营业配置
export function setMachineBusinessHoursApi(data) {
  return postJson(
    `/machines/detail/machineBusinessHours`,
    data
  )
}

// 下发图片
export function postDownPicApi(data) {
  return postJson(
    '/machine/shel/goods/picture/down',
    data,
  );
}



// WEBPACK FOOTER //
// ./src/api/machine.js